//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { ToneColor } from "./types";
import { ObjectTypeBadge } from "./ObjectTypeBadge";

export interface ObjectHeaderProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  type?: string;
  identifier?: string;
  typeColor?: ToneColor;
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  statusBand?: ReactNode;
  attributes?: ReactNode;
  avatar?: ReactNode;
}

/** Detail-page header: what this object is, its key facts, lifecycle, actions. */
export function ObjectHeader({
  type,
  identifier,
  typeColor = "brand",
  title,
  subtitle,
  actions,
  statusBand,
  attributes,
  avatar,
  className = "",
  ...rest
}: ObjectHeaderProps) {
  return (
    <header className={`bui-obj-header ${className}`} {...rest}>
      <div className="bui-obj-header__top">
        <div style={{ minWidth: 0, display: "flex", gap: 16, alignItems: "flex-start" }}>
          {avatar}
          <div style={{ minWidth: 0 }}>
            <ObjectTypeBadge type={type} identifier={identifier} color={typeColor} />
            {title && <h1 className="bui-obj-header__title">{title}</h1>}
            {subtitle && <p className="bui-obj-header__sub">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="bui-obj-header__actions">{actions}</div>}
      </div>
      {attributes && (
        <div style={{ display: "flex", gap: 32, flexWrap: "wrap", marginTop: 20 }}>
          {attributes}
        </div>
      )}
      {statusBand}
    </header>
  );
}
